import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { UserService } from '../../service/user.service';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the ProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage {

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public us:UserService,
    private storage: Storage,
    private alertCtrl: AlertController,
    private toastController: ToastController) { 
  }

  changePassword() {

    let alert = this.alertCtrl.create({
      title: 'Nytt lösenord',
      inputs: [
        {
          name: 'password',
          placeholder: 'Lösenord'
        }
      ],
      buttons: [
        {
          text: 'Avbryt',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Spara',
          handler: data => {

            this.us.setPassword(data.password).subscribe(data => {

              if (data == "OK")
              {
                  this.toastController.create({
                    message: 'Ditt lösenord är ändrat',
                    duration: 5000,
                    position: "middle"
                  }).present();
              }
              else
              {
                this.toastController.create({
                  message: 'Ett fel uppstod. Testa igen.',
                  duration: 5000,
                  position: "middle"
                }).present();
              }

            })
          }
        }
      ]
    });
    alert.present();

  }

  newQuality()
  {
    this.storage.set("quality", this.us.user.quality);
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts